/**
 * Orientation helpers — single source of truth for "is this size Landscape,
 * Portrait or Square?".
 *
 * Spread products (photobook, layflat, and any foldable editor) store the FULL
 * SPREAD width — two pages side by side — so a 1200×600 "size" is really two
 * 600×600 pages. Orientation must be judged per SINGLE page (width / 2), exactly
 * the rule the setCanvasSize reducer uses when it stores state.orientation.
 */

import { EDITOR_TYPES } from "../constants/index.js";

// Mirrors the setCanvasSize reducer's spread condition — keep both in lock-step.
const isHalfWidthSpread = (editorType, settings) =>
  editorType === EDITOR_TYPES.PHOTOBOOK ||
  editorType === EDITOR_TYPES.LAYFLATALBUM ||
  settings?.isFoldable === true;

// Full orientation word, judged per single page for spread products.
export const getSizeOrientation = (width, height, editorType, settings) => {
  let w = Number(width);
  const h = Number(height);
  if (isHalfWidthSpread(editorType, settings)) w = w / 2;
  if (w > h) return "Landscape";
  if (w < h) return "Portrait";
  return "Square";
};
